import { render, staticRenderFns } from "./TermsBoard.vue?vue&type=template&id=bf36dbb2&scoped=true"
import script from "./TermsBoard.vue?vue&type=script&lang=js"
export * from "./TermsBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf36dbb2",
  null
  
)

export default component.exports